import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}')({
  beforeLoad: () => getTitleContextSlice('Data Entities'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
